/* =====================================================
   afk-audio — ports & setups: tabs for the example setups.
   Arrow keys move between tabs; selecting a Setup block in
   the theme editor shows that setup.
   Also mounting + ports: the reference texts (details.rig-more)
   are closed on phones and open from 750 px up.
   ===================================================== */
(function () {
  'use strict';
  if (window.__afkRig) return;
  window.__afkRig = true;

  function init(root) {
    if (root.__rig) return;
    root.__rig = true;
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    // Without JS every setup is shown; with JS the tabs appear and only the active panel stays visible.
    root.classList.add('rig-js');
    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i, panel = document.getElementById(t.getAttribute('aria-controls'));
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panel) { panel.hidden = !on; panel.classList.toggle('is-active', on); }
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = tabs.length, j = -1;
        if (k === 'ArrowRight') j = (i + 1) % n;
        else if (k === 'ArrowLeft') j = (i - 1 + n) % n;
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = n - 1;
        if (j < 0) return;
        e.preventDefault();
        select(j, true);
      });
    });
    root.__rigSelect = select;
    var start = 0;
    tabs.forEach(function (t, k) { if (t.getAttribute('aria-selected') === 'true') start = k; });
    select(start, false);
  }

  // The markup ships the disclosures open, so without JS nothing is hidden.
  var MQ = window.matchMedia('(min-width: 750px)');
  function syncMore(scope) {
    [].forEach.call((scope || document).querySelectorAll('details.rig-more'), function (d) { d.open = MQ.matches; });
  }
  if (MQ.addEventListener) MQ.addEventListener('change', function () { syncMore(); });
  else if (MQ.addListener) MQ.addListener(function () { syncMore(); });

  function boot(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-rig-tabs]'), init);
    syncMore(scope);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target, root = tab.closest && tab.closest('[data-rig-tabs]');
    if (root && root.__rigSelect && tab.dataset.rigTab) root.__rigSelect(parseInt(tab.dataset.rigTab, 10), false);
    // a selected mount option or port shows its text in the editor's phone preview too
    if (tab.querySelectorAll) [].forEach.call(tab.querySelectorAll('details.rig-more'), function (d) { d.open = true; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
})();
